module.exports = __webpack_public_path__ + "img/d6512.cf5ccf3a.png";